/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DefinitionParameterValueSetDto } from './DefinitionParameterValueSetDto';
import {
    instanceOfDefinitionParameterValueSetDto,
    DefinitionParameterValueSetDtoFromJSON,
    DefinitionParameterValueSetDtoFromJSONTyped,
    DefinitionParameterValueSetDtoToJSON,
} from './DefinitionParameterValueSetDto';

/**
 * @type NumericEvaluationParameterDtoDefinitionParameterValueSet
 * 
 * @export
 */
export type NumericEvaluationParameterDtoDefinitionParameterValueSet = DefinitionParameterValueSetDto;


export function NumericEvaluationParameterDtoDefinitionParameterValueSetFromJSON(json: any): NumericEvaluationParameterDtoDefinitionParameterValueSet {
    return NumericEvaluationParameterDtoDefinitionParameterValueSetFromJSONTyped(json, false);
}

export function NumericEvaluationParameterDtoDefinitionParameterValueSetFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericEvaluationParameterDtoDefinitionParameterValueSet {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...DefinitionParameterValueSetDtoFromJSONTyped(json, true) };
    return  DefinitionParameterValueSetDtoFromJSONTyped(json, true);
}

export function NumericEvaluationParameterDtoDefinitionParameterValueSetToJSON(value?: NumericEvaluationParameterDtoDefinitionParameterValueSet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfDefinitionParameterValueSetDto(value)) {
        return DefinitionParameterValueSetDtoToJSON(value as DefinitionParameterValueSetDto);
    }

    return {};
}

/**
 * Check if a given object implements the NumericEvaluationParameterDtoDefinitionParameterValueSet interface.
 */
export function instanceOfNumericEvaluationParameterDtoDefinitionParameterValueSet(value: any): value is NumericEvaluationParameterDtoDefinitionParameterValueSet {
    if (instanceOfDefinitionParameterValueSetDto(value)) return true;
    return false;
}

